import React, { memo } from 'react';
import ChatChunk from './ChatChunk';

const ChatChunkList = ({ 
  messageChunks, 
  realtimeMessages, 
  membersMap, 
  currentUserId, 
  meetingId,  
  placeLatitude,
  placeLongitude,
  blockedIdSet,
}) => {
  return (
    <>
      {/* 메시지 청크들 렌더링 */}
      {messageChunks.map((chunk, index) => {

        return (
          <ChatChunk
            key={chunk.id}
            chunkId={chunk.id}
            messages={chunk.messages}
            membersMap={membersMap}
            currentUserId={currentUserId}
            isFirstChunk={index === messageChunks.length - 1}
            meetingId={meetingId}
            placeLatitude={placeLatitude}
            placeLongitude={placeLongitude}
            blockedIdSet={blockedIdSet}
          />
        );
      })}

      {/* 실시간 메시지 청크 */}
      {realtimeMessages.length > 0 && (
        <>
          <ChatChunk
            key="realtime"
            chunkId="realtime"
            messages={realtimeMessages}
            membersMap={membersMap}
            currentUserId={currentUserId}
            isFirstChunk={false}  
            meetingId={meetingId}
            placeLatitude={placeLatitude}
            placeLongitude={placeLongitude}
            blockedIdSet={blockedIdSet}
          />
        </>
      )}
    </>
  );
};

export default memo(ChatChunkList);